import { render, staticRenderFns } from "./Estaticos.vue?vue&type=template&id=02ff9118&scoped=true&"
import script from "./Estaticos.vue?vue&type=script&lang=js&"
export * from "./Estaticos.vue?vue&type=script&lang=js&"
import style0 from "./Estaticos.vue?vue&type=style&index=0&id=02ff9118&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ff9118",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VImg})
